"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as l } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const v = (_param)=>{
    var { color: c, size: h = 24 } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = l(), a = c !== null && c !== void 0 ? c : i ? t.colors.inverse : t.colors.neutralHigh, { skinName: r } = n();
    return r.match(/^blau/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: a,
            d: "M5.358 20.642V3.358h8.68V7.66h4.302v12.982zM15.396 4.317l1.985 1.985h-1.985zM14.998 2H4v20h15.698V6.7zm-2.79 15.058a3.26 3.26 0 0 1-2.75-1.511h3.825V14.19H8.97a3 3 0 0 1-.026-.397q.001-.202.026-.397h4.314v-1.358H9.458a3.263 3.263 0 0 1 5.253-.342l1.04-.872a4.62 4.62 0 0 0-3.543-1.654 4.63 4.63 0 0 0-4.275 2.868H6.83v1.358h.775a5 5 0 0 0-.02.397q.002.2.02.397H6.83v1.357h1.103a4.63 4.63 0 0 0 4.275 2.868c1.389 0 2.692-.617 3.574-1.692l-1.05-.861a3.26 3.26 0 0 1-2.524 1.196"
        })
    })) : r.match(/^o2-new/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: a,
            d: "M4.31 7.42 9.617 2h10.078v20H4.31zM9.206 7V4.44L6.7 7zM5.71 20.57h12.587V3.43h-7.692v5H5.711zm9.656-9.804a3.95 3.95 0 0 0-2.009-.553c-1.978 0-3.624 1.472-3.96 3.396h-.416a.707.707 0 0 0-.698.713c0 .393.313.713.698.713h.416c.331 1.924 1.978 3.39 3.956 3.39.702 0 1.396-.191 2.009-.552a.72.72 0 0 0 .255-.974.69.69 0 0 0-.953-.26 2.6 2.6 0 0 1-1.311.36c-1.204 0-2.215-.835-2.524-1.964h2.698c.385 0 .698-.32.698-.713a.707.707 0 0 0-.698-.713H10.83c.304-1.134 1.32-1.966 2.524-1.966.456 0 .913.124 1.31.361a.693.693 0 0 0 .959-.26.724.724 0 0 0-.256-.978"
        })
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: a,
            d: "M4.31 7.42 9.617 2h10.078v20H4.31zM9.206 7V4.44L6.7 7zM5.71 20.57h12.588V3.43h-7.693v5H5.711zm9.657-9.804a3.95 3.95 0 0 0-2.01-.553c-1.978 0-3.624 1.472-3.96 3.396h-.416a.707.707 0 0 0-.698.713c0 .393.313.713.698.713h.416c.331 1.924 1.978 3.39 3.956 3.39.702 0 1.396-.191 2.009-.552a.72.72 0 0 0 .255-.974.69.69 0 0 0-.953-.26 2.6 2.6 0 0 1-1.311.36c-1.204 0-2.215-.835-2.524-1.964h2.698c.385 0 .698-.32.698-.713a.707.707 0 0 0-.698-.713H10.83c.304-1.134 1.32-1.966 2.524-1.966.456 0 .913.124 1.31.361a.693.693 0 0 0 .959-.26.724.724 0 0 0-.255-.978"
        })
    }));
}, f = v;
export { f as default };
